import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import DPIProfilesHelpModal from "./Help";
import DPIProfileSettingsHelpModal from "./SettingsHelp";
import DPIPredfinedProfilesModal from "./DpiPredifinedProfilesModal";
import { composedAPI } from "./api";
import dpiComposition from "./composition";

const ConfigDPIProfiles = ({ ...settings }) => (
  <>
    <ProfilesAndSettings {...dpiComposition} {...composedAPI} {...settings} />
    <DPIProfilesHelpModal />
    <DPIProfileSettingsHelpModal />
    <DPIPredfinedProfilesModal />
  </>
);

export default ConfigDPIProfiles;
